// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l2iCc","tabsBox":"styles_tabsBox__1crtF","createButton":"styles_createButton__2FSO1"};